import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/v1.0/external/dashboard`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set('authorization', token);
      }
      return headers;
    },
  }),
  tagTypes: ['Dashboard'],
  endpoints: (builder) => ({
    getUtilizationDashboard: builder.query({
      query: () => ({
        url: `/utilization`,
        // params: { instanceId, from, to },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Dashboard'],
    }),
    getCapacityDashboard: builder.query({
      query: () => ({
        url: `/capacity`,
        // params: { instanceId, from, to },
      }),
      transformResponse: (response) => response.data,
      providesTags: ['Dashboard'],
    }),
  }),
});

export const {
  useGetUtilizationDashboardQuery,
  useLazyGetUtilizationDashboardQuery,
  useGetCapacityDashboardQuery,
  useLazyGetCapacityDashboardQuery,
} = dashboardApi; 